import { Component, OnInit, TemplateRef } from '@angular/core';
import { Product } from './product';
import { ProductService } from './product.service';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { Dtd } from '../dtd/dtd';
import { DtdService } from '../dtd/dtd.service';
import { Outputformat } from '../outputformat/outputformat';
import { OutputformatService } from '../outputformat/outputformat.service'
import { Businessunit } from '../businessunit/businessunit';
import { BusinessunitService } from '../businessunit/businessunit.service';
import { UserService } from '../user/user.service';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Product';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  productForm: FormGroup;
  products: Product[] = [];
  productsactive: Product[] = [];
  product: Product;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  productModalRef: BsModalRef;
  operation: string;
  userid: number;
  productid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  dtdList: Dtd[] = []; outputFormatList: Outputformat[] = []; businessUnitList: any = []; dtdDDLSettings: any;
  outputformatDDLSettings: any; selecteddtdids: any = []; selectedoutputformatids: any = [];
  NotificationMailDDLSettings: any;
  selectedMailids = [];
  notificationmailids = [];
  focusinto = false;
  constructor(
    private productservice: ProductService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService, private dtdservice: DtdService,
    private outputformatService: OutputformatService, private businessunitService: BusinessunitService, 
    private userService: UserService, private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Product_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Product_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Product_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Product_action');
    } 
  }

  //get f() { return this.userForm.controls; }
  ngOnInit() {
    this.checkIsMenuMapped();
    this.productForm = this.formBuilder.group({
      productid: [''],
      product: ['', [Validators.required]],
      productname: ['', [Validators.required]],
      dirpath: ['', Validators.required],
      xmlcontentarea: [''], outputformatid: [''], dtdid: [''], businessunitid: [0],
      active: [''],
      notificationemailid: [],
      externalmailid: ['']
    });
    this.searchText = '';
    this.getAll();
    this.getDtdMaster(); this.getoutputFormatMaster(); this.getbusinessmaster();

    this.dtdDDLSettings = {
      singleSelection: false,
      idField: 'dtdid',
      textField: 'dtd',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit:2,
      allowSearchFilter: true
    };
    this.outputformatDDLSettings = {
      singleSelection: false,
      idField: 'outputformatid',
      textField: 'outputformat',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit:2,
      allowSearchFilter: true
    };

    this.NotificationMailDDLSettings = {
      singleSelection: false,
      idField: 'userid',
      textField: 'emailid',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      // itemsShowLimit:2,
      allowSearchFilter: true
    };

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  key: string = 'product'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getDtdMaster() {
    this.dtdservice.GetActive().subscribe(res => { this.dtdList = res }, err => { this.toastr.error('Not able to get DTD data') })
  }
  getoutputFormatMaster() {
    this.outputformatService.GetActiveFormats().subscribe(res => { this.outputFormatList = res }, err => { this.toastr.error("Not able to get Outputformat data") })
  }
  getbusinessmaster() {
    this.businessunitService.GetActives().subscribe(res => {
      this.businessUnitList = res
      //alert(this.businessUnitList)
    },
      err => { this.toastr.error("Not able to get Businessunit data") })
  }



  frameIdtext(idlist, type) {
    
    var formatedstring = ''; var idList = []
    if (type == 'dtd')
      idList = idlist.dtdid;
    if (type == 'outputformat')
      idList = idlist.outputformatid
    // var useridList = useridlist.mailids;

    if (idList.length > 0) {
      if (type == 'dtd') {
        idList.forEach((d) => {
          this.dtdList.forEach((data, ind) => {
            if (data.dtdid == d.dtdid) {

              if (formatedstring == '')
                formatedstring = data.dtd
              else
                formatedstring = formatedstring + ',' + data.dtd;
            }
          });
        });
      }

      if (type == 'outputformat') {
        idList.forEach((d) => {
          this.outputFormatList.forEach((data, ind) => {
            if (data.outputformatid == d.outputformatid) {
              if (formatedstring == '')
                formatedstring = data.outputformat;
              else
                formatedstring = formatedstring + ',' + data.outputformat;
            }
          });
        });
      }
    }

    return formatedstring
  }






  getcustomlist(idlist, type) {
    var tempList = [];
    if (idlist) {
      if (type == 'dtd')
        idlist = idlist.dtdid;
      if (type == 'outputformat')

        idlist = idlist.outputformatid;

      if ((idlist != null) && (idlist.length != 0)) {
        if (type == 'dtd') {
          idlist.forEach((d) => {
            this.dtdList.forEach((data, ind) => {
              if (data.dtdid == d.dtdid) {
                tempList.push({
                  dtdid: data.dtdid, dtd: data.dtd
                });
              }
            });
          });
        }
      }
      if (type == 'outputformat') {
        idlist.forEach((d) => {
          this.outputFormatList.forEach((data, ind) => {
            if (data.outputformatid == d.outputformatid) {
              tempList.push({
                outputformatid: data.outputformatid, outputformat: data.outputformat
              });
            }
          });
        });
      }

    }
    return tempList;
  }

  SaveStructure(list, type) {
    var temp = [];
    if (list.length > 0) {
      if (type == 'dtd') {
        list.forEach(item => {
          temp.push({ dtdid: item.dtdid })
        })
      }
      if (type == 'outputformat') {
        list.forEach(item => {
          temp.push({ outputformatid: item.outputformatid })
        })
      }
    }
    return temp;
  }


  //getAll() {
  //  this.products = [];
  //  this.productsactive = [];
  //  this.productservice.Get().subscribe(res => {
  //    this.products = res;
  //    this.products.forEach((data, ind) => {
  //      //if (ind >= 79) {
  //      if (data.dtdid) {
  //        let a = this.frameIdtext(JSON.parse(data.dtdid), 'dtd')
  //        //data.notificationmailid = a// this.framemailIds(JSON.parse(data.notificationmailid))
  //        data['dtdtext'] = a// this.framemailIds(JSON.parse(data.dtdid), 'dtd');
  //        
  //      }
  //      if (data.outputformatid) {
  //        let b = this.frameIdtext(JSON.parse(data.outputformatid), 'outputformat')
  //        //data.notificationmailid = a// this.framemailIds(JSON.parse(data.notificationmailid))
  //        data['outputformattext'] = b
  //        // }
  //      }
  //    })
  //    if (this.showallstatus == true) {

  //      this.products.forEach(data => {
  //        if (data.active == 1) {
  //          this.productsactive.push(data);
  //        }
  //      });
  //      this.products = [];
  //      this.products = this.productsactive;
  //    }
  //  }, error => { this.toastr.error('Error while getting data'); });

  //}

  getAll() {
    this.products = [];
    this.productsactive = [];

    Promise.all([this.userService.GetActive().toPromise(), this.productservice.Get().toPromise()]).then(([userRes, productRes]) => {
      this.notificationmailids = userRes;
      this.products = productRes;
      this.products.forEach((data, ind) => {
        // if (ind >= 79) {
        if (data.dtdid) {
          let a = this.frameIdtext(JSON.parse(data.dtdid), 'dtd')
          // data.notificationmailid = a// this.framemailIds(JSON.parse(data.notificationmailid))
          data['dtdtext'] = a; // this.framemailIds(JSON.parse(data.dtdid), 'dtd');
          
        }
        if (data.outputformatid) {
          let b = this.frameIdtext(JSON.parse(data.outputformatid), 'outputformat')
          // data.notificationmailid = a// this.framemailIds(JSON.parse(data.notificationmailid))
          data['outputformattext'] = b;
          // }
        }

        if (data.notificationemailid) {
          let a = this.framemailIds(JSON.parse(data.notificationemailid));
          // data.notificationmailid = a// this.framemailIds(JSON.parse(data.notificationmailid))
          data['notificationmailidtext'] = a;
          // }
        }
        if (data.externalmailid) {
          data['externalmailidtext'] = this.getemailstring(JSON.parse(data.externalmailid));
        }

      });
      if (this.showallstatus == true) {

        this.products.forEach(data => {
          if (data.active == 1) {
            this.productsactive.push(data);
          }
        });
        this.products = [];
        this.products = this.productsactive;
      }
    }, error => {
      this.toastr.error('Error while getting data');
    });



  }

  getactiveinactive(showallp) {
    this.productsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.products.forEach(data => {
        if (data.active == 1) {
          this.productsactive.push(data);
        }
      });
      this.products = [];
      this.products = this.productsactive;
    }
    else {
      this.showall = true;
      this.products = [];
      this.getAll();
    }
  }

  get g() { return this.productForm.controls; }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedproduct");
    let data = arrays.find(ob => ob['name'] === 'Product');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedproduct","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedproduct",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.productModalRef.hide();
    this.selecteddtdids = []; this.selectedoutputformatids = [];
  }

  Post(product: Product) {
    var dtdids = {}; var outputformatids = {};
    this.submitted = true;
    // stop here if form is invalid
    //if (this.productForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.productForm.errors);
    //}
    if ((product.product.trim() == undefined) || (product.product.trim() == '')) {
      this.toastr.error('Product should not be empty');
      return;
    }
   
    var msg = null;
    
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    product.product = product.product.trim();
    dtdids['dtdid'] = this.SaveStructure(this.selecteddtdids, 'dtd')
    product.dtdid = JSON.stringify(dtdids)
    outputformatids['outputformatid'] = this.SaveStructure(this.selectedoutputformatids, 'outputformat')
    product.outputformatid = JSON.stringify(outputformatids);

    let mailIds = {};
    mailIds['mailto'] = this.mailSaveStructure(this.selectedMailids);
    product.notificationemailid = JSON.stringify(mailIds);

    let regxpat = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    let validmailid = false;
    let externalMailList = [];
    if (product.externalmailid) {
      if (product.externalmailid.trim() != null && product.externalmailid.trim() !== '') {
        let b = product.externalmailid.split(';');
        b.forEach(data => {
          if (!regxpat.test(data)) {
            this.toastr.warning('Please enter valid  External Mail id instead of ' + data)
            validmailid = false;
          } else {
            externalMailList.push(data);
            validmailid = true;
          }
        })
        if (!validmailid) {
          return;
        }
      }
    }
    product.externalmailid = JSON.stringify(externalMailList);


    if (this.operation == 'add') {

      product.createdby = this.userid;
      msg = "Record Added Successfully";
      this.productservice.Post(product).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.productModalRef.hide();
              this.selecteddtdids = []; this.selectedoutputformatids = []
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      product.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.productservice.Put(product).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.productModalRef.hide();
              this.selecteddtdids = []; this.selectedoutputformatids = []
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.productForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.productForm.value.active = 1;
    } else {
      this.productForm.value.active = 0
    }
  }

  OpenConfirmTemplate(product, template: TemplateRef<any>) {
    if (product.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.product = product;

          this.Delete();

        }
       
      });

  }


  Delete() {
    var msg;
    if (this.product.active == 0) {
      this.product.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.product.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.product.modifiedby = this.userid;
    this.productservice.Delete(this.product).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.productModalRef.hide();
  }
  openProductModal(template: TemplateRef<any>, type, product ?: Product,) {
    this.operation = type
    
    if (type == 'update') {
      this.productForm.controls['productid'].setValue(product.productid);
      this.productForm.controls['product'].setValue(product.product);
      this.productForm.controls['productname'].setValue(product.productname);
      this.productForm.controls['active'].setValue(product.active);
      this.productForm.controls['dirpath'].setValue(product.dirpath);
      this.productForm.controls['businessunitid'].setValue(product.businessunitid);
      this.productForm.controls['xmlcontentarea'].setValue(product.xmlcontentarea);
      this.selecteddtdids = this.getcustomlist(JSON.parse(product.dtdid), 'dtd');
      this.selectedoutputformatids = this.getcustomlist(JSON.parse(product.outputformatid), 'outputformat');
     
      this.selectedMailids = this.getcustomMaillist(JSON.parse(product.notificationemailid));
      var extmailids = this.getemailstring(JSON.parse(product.externalmailid));
      this.productForm.controls['externalmailid'].setValue(extmailids);
      this.product = product;

    }
    if (type == 'add') {
      this.productForm.controls['productid'].setValue(0);
      this.productForm.controls['product'].setValue('');
      this.productForm.controls['productname'].setValue('');
      this.productForm.controls['active'].setValue(1);
      this.productForm.controls['dirpath'].setValue('');
    }
    this.productModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }

  framemailIds(useridlist) {
    let mailids = '';
    let useridList = useridlist.mailto;
    if (useridList.length > 0) {
      useridList.forEach((d) => {
        this.notificationmailids.forEach((data, ind) => {
          if (data.userid == d.userid) {
            if (mailids == '') {
              mailids = data.emailid;
            } else {
              mailids = mailids + ',' + data.emailid;
            }
          }
        });
      });
    }

    return mailids;
  }

  getemailstring(externallist) {
    if (externallist) {
      var externalToliststr = '';
      externallist.forEach((d) => {
        if (externalToliststr == '') {
          externalToliststr = d;
        } else {
          externalToliststr = externalToliststr + ';' + d;
        }
      });
    }
    return externalToliststr;
  }

  mailSaveStructure(list) {
    var temp = [];
    if (list.length > 0) {
      list.forEach(item => {
        temp.push({ userid: item.userid })
      });
    }
    return temp;
  }

  getcustomMaillist(idlist) {

    var tempList = [];
    if (idlist) {
      var idList = idlist.mailto;
      if ((idList != null) && (idList.length != 0)) {

        idList.forEach((d) => {
          this.notificationmailids.forEach((data, ind) => {
            if (data.userid == d.userid) {
              tempList.push({
                userid: data.userid, emailid: data.emailid
              });
            }
          });
        });

      }
    }

    return tempList;
  }



}
